import axios from "axios";
import "../../common/axiosInterceptor/axios-interceptor";

export const NX5_RegistrationDetails_API = async () => {
    return axios({
        method: 'get',
        url: `${process.env.REACT_APP_API_BASE_URL}/admindashboard/api/Noccarc/PM/NX5/getMachineRegistrationDetails`,
        authRequired: true
    })
}